"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Effect_CurseSiphonEventHandlerScript = void 0;
const DelayedDamage_1 = require("../../core/DelayedDamage");
const Registries_1 = require("../../core/state/Registries");
let Effect_CurseSiphonEventHandlerScript = class Effect_CurseSiphonEventHandlerScript {
    run(sequence, container, handler, event) {
        const { damage } = container.applyDoTDamageV2({
            sequence,
            attackerId: handler.args.scriptArgs.creatorId,
            targetId: event.subject,
            damage: new DelayedDamage_1.DelayedDamage("Curse", handler.args.scriptArgs.attributeType, "Death", handler.args.scriptArgs.power)
        });
        const siphonAmount = Math.round(damage.amount * handler.args.scriptArgs.healingPercent);
        container.applyHealing({
            sequence,
            healerId: handler.args.scriptArgs.creatorId,
            targetId: handler.args.scriptArgs.creatorId,
            amount: siphonAmount
        });
    }
};
Effect_CurseSiphonEventHandlerScript = __decorate([
    Registries_1.EventHandlerScripts.register("Effect_CurseSiphon")
], Effect_CurseSiphonEventHandlerScript);
exports.Effect_CurseSiphonEventHandlerScript = Effect_CurseSiphonEventHandlerScript;
